export class LoginRequest {
  username: string;
  password: string;

  constructor(username: string, password: string) {
    this.username = username;
    this.password = password;
  }
}

export class RefreshLoginRequest {
  refreshToken: string;

  constructor(refreshToken: string) {
    this.refreshToken = refreshToken;
  }
}

export class LogoutRequest {
  refreshToken: string;

  constructor(refreshToken: string) {
    this.refreshToken = refreshToken;
  }
}

export class AuthUser {
  userID: number;
  benutzer: string;
  username: string;
  token: string;
  refreshToken: string;

  constructor() {
    this.userID = 0;
    this.benutzer = '';
    this.username = '';
    this.token = '';
    this.refreshToken = '';
  }
}
